/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { FindProductStandardCertificateTypeDto } from "./FindProductStandardCertificateTypeDto.ts"
import type { FindProductsStandardProductionSiteDto } from "./FindProductsStandardProductionSiteDto.ts"

export const findProductsProductStandardCertificateDtoStatusEnum = {
  NOT_UPLOADED: "NOT_UPLOADED",
  PENDING: "PENDING",
  PROCESSED: "PROCESSED",
  REJECTED: "REJECTED",
} as const

export type FindProductsProductStandardCertificateDtoStatusEnumKey =
  (typeof findProductsProductStandardCertificateDtoStatusEnum)[keyof typeof findProductsProductStandardCertificateDtoStatusEnum]

export type FindProductsProductStandardCertificateDto = {
  /**
   * @type string
   */
  id: string
  /**
   * @type string
   */
  certificateId: string | null
  /**
   * @type string, date-time
   */
  createdAt: Date
  /**
   * @type object
   */
  type: FindProductStandardCertificateTypeDto
  /**
   * @type string
   */
  reference: string | null
  /**
   * @type string, date-time
   */
  issueDate: Date | null
  /**
   * @type string, date-time
   */
  expiryDate: Date | null
  /**
   * @type string
   */
  score: string | null
  /**
   * @type string
   */
  name: string
  /**
   * @type string
   */
  status: FindProductsProductStandardCertificateDtoStatusEnumKey
  /**
   * @type string
   */
  documentId: string | null
  /**
   * @type array
   */
  productCategories: string[]
  /**
   * @type array
   */
  processingSteps: string[]
  /**
   * @type array
   */
  productDetails: string[]
  /**
   * @type string
   */
  buyerOfCertifiedProducts: string | null
  /**
   * @type string
   */
  certifiedOrganizationAddress: string | null
  /**
   * @type string
   */
  certifiedWeight: string | null
  /**
   * @type string
   */
  linkedScopeCertificateNumber: string | null
  /**
   * @type string
   */
  certificationBody: string | null
  /**
   * @type string
   */
  certifiedOrganizationLicenseNumber: string | null
  /**
   * @type string
   */
  certifiedOrganizationName: string | null
  /**
   * @type string
   */
  productPurchaseOrder: string | null
  productionSite: FindProductsStandardProductionSiteDto | null
}
